import script from "./Goal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Goal.vue?vue&type=script&setup=true&lang=ts"

import "./Goal.vue?vue&type=style&index=0&id=343b481f&lang=scss"

const __exports__ = script;

export default __exports__